import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ToasterContainerComponent } from './shared/components/toaster';

import { Chart, registerables } from 'chart.js';
Chart.register(...registerables);

@Component({
    selector: 'app-root',
    standalone: true,
    imports: [RouterOutlet, ToasterContainerComponent],
    templateUrl: './app.component.html',
    styleUrl: './app.component.sass',
})
export class AppComponent {}
